export const tagsMatches = (introTags, tags) =>
  tags.some(({ id }) => introTags.some(tag => tag.sys.id === id));
